import React from "react";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px" }}>
        <h2>Privacy Policy</h2>
        <div className="mt-4">
          <p>
            <b>Last updated : </b> 27 Feb 2025
          </p>
          <p>
            <b>1. Introduction</b>
            <br />
            Our appointment booking platform &nbsp;
            <a href="https://psychooncology.online">https://psychooncology.online</a> is
            committed to protecting your privacy. This Privacy Policy explains
            how we collect, use, store, and share your personal data when you
            access or use our services, including our integration with Zoom for
            scheduling online meetings. By using our Application, you agree to
            the practices described herein.
          </p>
          <br />
          <p>
            <b>2. Information We Collect</b>
          </p>
          <p>
            <b>a. Personal Information:</b>
            <br />
            <ul>
              <li>
                <b>Counsellors:</b> When counsellors register, create
                availability, and connect their Zoom accounts, we may collect
                your name, email address, mobile number, and other contact
                information (as stored in our LoginMaster table).
              </li>
              <li>
                <b>Clients:</b> When clients book appointments, we collect
                similar personal data (name, email, and contact details) to
                process and confirm their bookings.
              </li>
            </ul>
          </p>
          <p>
            <b>b. Appointment Details:</b>
            <br />
            <ul>
              <li>Date, time, and duration of appointments.</li>
              <li>
                Meeting information including Zoom meeting links, which are
                generated automatically when an appointment is booked.
              </li>
            </ul>
          </p>
          <p>
            <b>c. Zoom Integration Data:</b>
            <br />
            <ul>
              <li>
                We collect Zoom OAuth tokens (access and refresh tokens), token
                expiry information, and related metadata to facilitate meeting
                creation on behalf of counsellors.
              </li>
              <li>
                These tokens are stored in our database in the
                CounselorZoomAccounts table and are used solely to create and
                manage Zoom meetings for scheduled appointments.
              </li>
            </ul>
          </p>
          <br />
          <p>
            <b>3. How We Use Your Information</b>
          </p>
          <p>
            <b>Appointment Scheduling:</b>
            <br />
            We use your personal data and appointment details to enable booking,
            scheduling, and management of counselling sessions.
          </p>
          <p>
            <b>Zoom Meeting Integration:</b>
            <br />
            When a client books an appointment, our system automatically uses
            the stored Zoom credentials of the connected counsellor to create a
            Zoom meeting. The meeting link is then shared with the client and
            stored with the appointment record.
          </p>
          <p>
            <b>Communication:</b>
            <br />
            We may use your contact information to send appointment
            confirmations, reminders, and related notifications.
          </p>
          <p>
            <b>Security and Maintenance:</b>
            <br />
            We use the data to monitor and improve our Application’s performance
            and to ensure a secure and reliable user experience.
          </p>
          <br />
          <p>
            <b>4. How We Store and Protect Your Information</b>
          </p>
          <p>
            <b>Storage:</b>
            <br />
            <ul>
              <li>
                All personal and transactional data is stored in our SQL Server
                database.
              </li>
              <li>
                Zoom tokens and meeting details are stored in the
                CounselorZoomAccounts and AppointmentBookings tables
                respectively.
              </li>
            </ul>
          </p>
          <p>
            <b>Security Measures:</b>
            <br />
            We use industry-standard security practices including HTTPS for data
            transmission and access controls for our databases. While we
            currently store tokens in plain text within secured database fields,
            we plan to implement additional encryption measures as part of our
            ongoing security enhancements.
          </p>
          <p>
            <b>Data Retention:</b>
            <br />
            We retain your personal information for as long as necessary to
            provide our services and as required by law. Meeting details and
            Zoom tokens are retained for the duration of the appointment’s
            lifecycle and are purged or archived according to our data retention
            policies.
          </p>
          <br />
          <p>
            <b>5. Information Sharing and Disclosure</b>
          </p>
          <p>
            <b>Third-Party Service Providers:</b>
            <br />
            We do not sell or lease your personal information. However, we may
            share information with trusted third-party service providers (such
            as Zoom) strictly for the purpose of providing our services. These
            providers are bound by confidentiality agreements and are not
            permitted to use your data for any other purpose.
          </p>
          <p>
            <b>Legal Requirements:</b>
            <br />
            We may disclose personal information if required to do so by law or
            in response to valid legal requests.
          </p>
          <br />
          <p>
            <b>6. Third-Party Integrations</b>
          </p>
          <p>
            <b>Zoom:</b>
            <br />
            Our Application integrates with Zoom to create online meeting links
            for appointments. When you connect your Zoom account, we receive
            OAuth tokens (access and refresh tokens) from Zoom which are stored
            to enable meeting creation. This data is used solely for this
            purpose and is not shared with any other third parties.
          </p>
          <br />
          <p>
            <b>7. Your Rights and Choices</b>
          </p>
          <p>
            <b>Access and Correction:</b>
            <br />
            You have the right to access, update, or correct your personal
            information by contacting us through our support channels.
          </p>
          <p>
            <b>Opt-Out:</b>
            <br />
            You may opt-out of receiving promotional communications; however,
            this will not affect the essential functionalities of appointment
            booking and meeting scheduling.
          </p>
          <p>
            <b>Data Deletion:</b>
            <br />
            Upon request (subject to legal obligations), we can delete your
            personal data. Please note that deleting certain data might affect
            your ability to use our services.
          </p>
          <br />
          <p>
            <b>8. Data Collection and Use </b>
            <br />
            We collect personal information from users during registration,
            appointment booking, and profile setup. For example, patients
            provide their name, email address, mobile number, date of birth,
            gender, and address details, while counsellors provide additional
            professional details. This information is used solely to
            authenticate users, manage appointments, and enable video meeting
            integrations with Zoom. Our system also collects Zoom OAuth token
            data (access and refresh tokens) when counsellors connect their Zoom
            accounts. In addition, with our planned payment gateway integration,
            we collect minimal financial data (processed exclusively by our
            PCI-DSS compliant provider) necessary to complete transactions.
          </p>
          <br />
          <p>
            <b>8. Changes to This Privacy Policy</b>
          </p>
          <p>
            We periodically review and update this Privacy Policy. Any changes
            will be posted on our website with a revised effective date. We
            encourage you to review this policy periodically.
          </p>
          <br />
          <p>
            <b>9. Contact Us</b>
          </p>
          <p>
            If you have any questions about this Privacy Policy or our data
            practices, please contact our Data Protection Officer at:
            <br />
            <b>Email:</b>{" "}
            <a href="mailto:info@psychooncology.online">info@psychooncology.online</a>{" "}
            <br />
            <b>Address:</b> Texas School of Mental Health, kothrud, pune.
          </p>
        </div>
      </Container>
      <CommonFooter />
    </>
  );
};
export default PrivacyPolicy;
